import styled from "styled-components";
import { DigitalShareAppType } from "../../../Enums/Enums";
import { device } from "../../../globalStyles";

export const ProgressScreenBackdrop = styled("div")`
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: #000;
  opacity: 0.3;
  z-index: 999999;
  top: 0;
  left: 0;
`;

export const ProgressScreenContainer = styled("div")`
  width: calc(100vw - 70px);
  height: calc(100vh - 70px);
  position: fixed;
  z-index: 9999999;
  top: 35px;
  left: 35px;
  overflow: hidden;

  background-color: #2e3d49;
  border-radius: 5px;
  animation: fadeIn;
  animation-duration: 0.5s;
`;

export const ProgressScreenContent = styled("div")`
  width: 100%;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;

  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const ProgressScreenBackground = styled("div")`
  width: 50%;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  background-color: #fff;
`;

export interface ProgressScreenTaglineProps {
  app: DigitalShareAppType;
}

const getMediaMaxWidth = (app: DigitalShareAppType) => {
    if (app === DigitalShareAppType.RetailMatch) {
        return "1360px";
    }
    return "1480px";
};

export const ProgressScreenTagline = styled("div")`
  height: 100%;
  flex-grow: 0;
  max-width: 500px;
  margin-right: 70px;
  padding-top: 180px;

  ${device.upToTabletL} {
    visibility: hidden;
  }
`;

export const ProgressScreenRightSectionContainer = styled("div")`
  width: 740px;
  flex-grow: 0;
  position: relative;
  margin-left: 100px;

  ${device.upToTabletL} {
    margin-left: 0;
  }
`;

export const ProgressScreenRightSection = styled("div")`
  width: 740px;
  height: 1000px;
  position: absolute;
  left: -200px;
  top: 0;
  bottom: 0;
  margin: auto;
  margin-left: 40px;
  background-color: #fff;
  opacity: 1;
  z-index: 9999999;
  text-align: center;
  border-radius: 50% 0 0 50%;
  flex-grow: 0;
`;

export const ProgressBarContainer = styled("div")`
  max-width: 600px;
  height: 330px;
  position: absolute;
  right: 40px;
  top: 0;
  bottom: 0;
  margin: auto;

  ${device.upToTabletL} {
    right: 100px;
  }
`;

export const ProgressBarBorder = styled("div")`
  max-width: 600px;
  height: 60px;
  border: 2px solid #e5e5e5;
  text-align: left;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  justify-content: space-around;

  & .progress-screen-checkmark {
    flex-grow: 0;
    flex-shrink: 0;
    width: 34px;
    margin: 0 14px;
  }
`;

export const ProgressBarTrack = styled("div")`
  width: 518px;
  height: 26px;
  position: relative;
  border: 2px solid #e5e5e5;
  text-align: left;
  margin: 15px;
`;

interface ProgressBarProgressProps {
  percentComplete: number;
}

export const ProgressBarProgress = styled("div")`
  width: ${(props: ProgressBarProgressProps) => props.percentComplete}%;
  height: 100%;
  display: inline-block;
  background-color: #1ce180;
  position: relative;
  left: 0;
`;

export const ProgressBarPercentCaption = styled("div")`
  text-align: center;
  position: relative;
  margin-bottom: 16px;
  font-family: "Manrope-ExtraBold";
  color: #515151;
  font-size: 108px;
  letter-spacing: -3px;

  ${device.upToTabletL} {
    font-size: 40px;
  }
`;

export const ProgressBarCaption = styled("div")`
  text-align: center;
  position: relative;
  margin-top: 28px;
  font-family: "Manrope-Regular";
  color: #6c7279;
  font-size: 26px;
`;

// export const RenderContainer = styled("div")`
//     flex-grow: 0;
//     flex-shrink: 0;
//     width: 1500px;
//     height: 835px;
// `;

export const RenderContainer = styled("div")`
  flex-grow: 0;
  flex-shrink: 0;
`;

export const RenderCollection = styled("div")`
  width: 1500px;
  display: flex;
  flex-direction: column;
`;

export const HideUpToTabletXtraLarge = styled("div")`
  ${device.upToTabletXl} {
    display: none;
  }
`;
